module.exports = __webpack_public_path__ + "img/ico-coin.86cd326a.svg";